import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Receipt() {
    const [customers, setCustomers] = useState([]);
    const [receipt, setReceipt] = useState({ customer_id: '', amount: 0, date: new Date().toISOString().split('T')[0], note: '' });

    useEffect(() => {
        fetchCustomers();
    }, []);

    const fetchCustomers = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/customers`);
            setCustomers(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleReceipt = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${getApiUrl()}/receipts`, receipt);
            alert('Receipt Recorded');
            setReceipt({ customer_id: '', amount: 0, date: new Date().toISOString().split('T')[0], note: '' });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Payment Receipt</h2>
                <form onSubmit={handleReceipt} className="card p-4">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label">Customer</label>
                            <select className="form-select" value={receipt.customer_id} onChange={e => setReceipt({...receipt, customer_id: e.target.value})} required>
                                <option value="">Select Customer</option>
                                {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Amount</label>
                            <input type="number" className="form-control" value={receipt.amount} onChange={e => setReceipt({...receipt, amount: parseFloat(e.target.value)})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Date</label>
                            <input type="date" className="form-control" value={receipt.date} onChange={e => setReceipt({...receipt, date: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-12">
                            <label className="form-label">Note</label>
                            <textarea className="form-control" value={receipt.note} onChange={e => setReceipt({...receipt, note: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-12 mt-3 d-grid d-md-block">
                            <button type="submit" className="btn btn-primary btn-lg">Save Receipt</button>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    );
}

export default Receipt;
